// extracted by mini-css-extract-plugin
export default {"linkBtn":"plan_linkBtn__Du3v7","disabledLink":"plan_disabledLink__G+ds4","wrapper":"plan_wrapper__AcpOg"};